export default __webpack_public_path__ + "static/media/satsure-iNetra.5a224b1f.png";